import React, { useEffect } from "react";
import { CommentDetail, HeaderConfig, ProgramContainer } from "../../../entities/formTemplateDataType";
import CMACommentComponent from "./CMACommentComponent";
import { format } from "date-fns";
import { TabMenu } from "primereact/tabmenu";
import CMAUtils from "../../../utilities/CMAUtils";

const tabItems = [
    { label: 'All comments' },
    { label: 'Unresolved comments' },
];

const tabItemsFR = [
    { label: 'Tous les commentaires' },
    { label: 'Commentaires non résolus' },
];

const CMACommentListComponent = ({
    programContainer,
    headerConfig,
    comments,
    cmaRole,
    profile,
    readOnly,
    isEng,
    callback,
    cancelComments,
    callbackCMASaved,
}: {
    programContainer: ProgramContainer,
    headerConfig: HeaderConfig,
    comments?: CommentDetail[],
    cmaRole: 'A' | 'C',
    profile?: any,
    readOnly: boolean,
    isEng: boolean,
    callback: (p: ProgramContainer) => void,
    cancelComments: () => void,
    callbackCMASaved: () => void
}) => {
    const [commentList, setCommentList] = React.useState<CommentDetail[]>(
        comments?.filter(c => c.func === headerConfig.func && c.category === headerConfig.category) ?? []
    );
    const [newComment, setNewComment] = React.useState<CommentDetail>({ Comments: '', MadeBy: '', MadeOn: '', role: cmaRole });
    const [updated, setupdated] = React.useState(false);
    const [activeTab, setActiveTab] = React.useState(0);

    const setComment = (value: string, comment: CommentDetail, index?: number, resolved = false) => {
        if (index < 0) {
            // edit new comment
            setNewComment({ ...newComment, Comments: value, Resolved: resolved, role: cmaRole });
            setupdated(true);
            return;
        }

        const comments = commentList.map((c, i) => {
            if (i === index) {
                return { ...c, Resolved: resolved, };
            }
            return c;
        });
        setupdated(true);
        setCommentList(comments);
        updateComments(comments);
        CMAUtils.saveCMA(programContainer, programContainer.Entity?.status).then(success => {
            if (success) {
                callbackCMASaved();
            }
        });
    }

    const sendComments = (e) => {
        console.log('sendComments', updated);
        if (!updated) return;
        const comments = [...commentList]
        e.preventDefault();
        if (newComment.Comments) {
            const comment = {
                ...newComment,
                MadeBy: profile?.Email,
                MadeOn: format(new Date(), 'yyyy-MM-dd HH:mm:ss'),
                role: cmaRole,
                category: programContainer.HeaderConfig?.category,
                func: programContainer.HeaderConfig?.func,
            }
            comments.push(comment);
            setCommentList(comments);
        }
        setNewComment({ Comments: '', MadeBy: '', MadeOn: '', role: cmaRole });
        setupdated(false);
        updateComments(comments);
        CMAUtils.saveCMA(programContainer, programContainer.Entity?.status).then(success => {
            if (success) {
                callbackCMASaved();
            }
        })
    }

    const handleCancelComments = () => {
        setNewComment({ Comments: '', MadeBy: '', MadeOn: '', role: cmaRole });
        setupdated(false);
        cancelComments();
    }

    const deleteComment = (index: number) => {
        const comments = commentList.filter((c, i) => i !== index);
        setCommentList(comments);
        setupdated(true);
        updateComments(comments);
        CMAUtils.saveCMA(programContainer, programContainer.Entity?.status).then(success => {
            if (success) {
                callbackCMASaved();
            }
        });
    }

    const updateComments = (updatingComments: CommentDetail[]) => {
        const otherComments = programContainer.Entity.comments
          ?.filter(
            c =>
              c.func !== headerConfig.func ||
              c.category !== headerConfig.category
          ) ?? [];
        programContainer.Entity.comments = [
          ...otherComments,
          ...updatingComments,
        ];
        callback(programContainer);
      };

    useEffect(() => {
        let tab = activeTab;
        let list = comments?.filter(c => c.func === headerConfig.func && c.category === headerConfig.category) ?? [];
        if (list.filter(c => !c?.Resolved).length === 0) {
            tab = 0;
        } else {
            list = tab === 0 ? list : list.filter(c => !c?.Resolved);
        }
        setCommentList(list);
        setActiveTab(tab);
    }, [comments])

    // useEffect(() => {
    //     const handleSendComments = (e) => {
    //         console.log('handleSendComments', e.target.closest('.message-items'), e.target.closest('.pop-up-button.ontario-button--primary'));
    //         if (e.target.closest('.message-items') && e.target.closest('.pop-up-button.ontario-button--primary')) sendComments(e);
    //     }

    //     document.addEventListener('click', handleSendComments);
    //     return () => {
    //         document.removeEventListener('click', handleSendComments);
    //     }
    // }, []);

    return (
        <>
            {comments.filter(c => !c?.Resolved).length > 0 && (
                <div className="tabs-section tabs-background">
                    <TabMenu model={isEng ? tabItems : tabItemsFR}
                        activeIndex={activeTab}
                        onTabChange={(e) => setActiveTab(e.index)}
                    />
                </div>
            )}
            <div className="message-items">
                {commentList?.map((comment, index) => {
                    if (activeTab == 1 && (comment.Resolved || comment.role == 'C')) return null; 
                    return (
                        <CMACommentComponent
                            key={`comment-${index}`}
                            data={comment}
                            index={index}
                            cmaRole={cmaRole}
                            isCommentOwner={comment.MadeBy?.toLocaleLowerCase() === profile?.Email?.toLocaleLowerCase()}
                            setComment={(value, index, resolved) => setComment(value, comment, index, resolved)}
                            deleteComment={deleteComment}
                            status={programContainer.Entity?.status}
                            readOnly={readOnly} 
                            isEng={isEng}
                            />
                    );
                })}
            </div>
            {activeTab === 0 && !readOnly && (
                <div className="message-items">
                    <p className="ontario-margin-bottom-16-!"><span style={{ fontWeight: '600' }}>{isEng ? "Add a comment" : "Ajouter un commentaire"}</span></p>
                    <CMACommentComponent
                        data={newComment}
                        newComment={true}
                        index={comments.length}
                        cmaRole={cmaRole}
                        isCommentOwner={true}
                        status={programContainer.Entity?.status}
                        setComment={(value, index) => setComment(value, newComment, -1)}
                        deleteComment={deleteComment} 
                        readOnly={readOnly}
                        isEng={isEng}
                        />
                    <div style={{ display: 'flex', justifyContent: 'flex-start', flexWrap: 'wrap', paddingTop: '8px' }}>
                        <button className="pop-up-button ontario-button--primary" disabled={!updated} onClick={sendComments}>{isEng ? "Post" : "Afficher"}</button>
                        <button className="pop-up-button ontario-button--secondary" onClick={handleCancelComments}>{isEng ? "Cancel" : "Annuler"}</button>
                    </div>
                </div>
            )}
        </>
    );
}

export default CMACommentListComponent;